import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { setConfiguration } from 'components/Grid';

import Home from 'features/Home/routes';

import GlobalStyle from './styles';

import '_translate';

setConfiguration({
  containerWidths: [540, 740, 960, 1140, 1280]
});

const App = () => (
  <>
    <GlobalStyle />
    <Router>
      <Switch>
        <Home />
      </Switch>
    </Router>
  </>
);

export default App;
